"use client";

// Re-export the appropriate ErrorBoundary based on environment
export { ErrorBoundary } from "./ErrorBoundary/index";

